export default "__VITE_ASSET__BBnh0_oM__"